import { someActionsPermissionIsEnabled } from '.'

export const LOG_ACTIONS_ENUM = {
  charge: ['charge.log.seq:get', 'charge.log.splunk:get'],
  order: ['order.log.seq:get', 'order.log.splunk:get']
}

const chargeLogEnabled = permissionIsEnabledFn => {
  return someActionsPermissionIsEnabled(
    LOG_ACTIONS_ENUM.charge,
    permissionIsEnabledFn
  )
}

const orderLogEnabled = permissionIsEnabledFn => {
  return someActionsPermissionIsEnabled(
    LOG_ACTIONS_ENUM.order,
    permissionIsEnabledFn
  )
}

export { chargeLogEnabled, orderLogEnabled }
